





































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import Role from '@/store/entities/role';
    @Component
    export default class EditRole extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
	    @Prop({type:Object,default:{}}) data:object;
        role:any =new Role();
	    permissionData:any = [
		    {
			    title:'所有',
			    value:1,
			    selected:false,
			    checked:false,
			    expand:true,
			    children:[]
		    }
	    ]
	    datas:any = this.data;
        get permissions(){
            return this.$store.state.role.permissions
        }
	    //判断子集是否有勾选
	    childrenChecked(list:any){
		    let checked = false;
		    list.forEach((item:any) => {
			    if(item.checked){
				    checked = true
			    }
		    });
		    return checked
	    }
        save(){
            (this.$refs.roleForm as any).validate(async (valid:boolean)=>{
                if(valid){
	                this.role.permissions=[];
	                //遍历树节点
	                this.permissionData[0].children.forEach((item:any,index:any)=>{
		                if(item.checked || this.childrenChecked(item.children)){
			                this.role.permissions.push(item.value)
		                }
		                item.children.forEach((item_c:any)=>{
			                if(item_c.checked){
				                this.role.permissions.push(item_c.value)
			                }
		                })
	                })
                    await this.$store.dispatch({
                        type:'role/update',
                        data:this.role
                    });
                    (this.$refs.roleForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
        }
        mounted(){
	        this.role = Object.assign({}, this.data)
	        this.role.parentId = this.role.roleType
	        this.getpermissions()
        }
	    async getpermissions(){
		    let data = await this.$store.dispatch({
			    type:'role/getPermissions'
		    })
		    let permissions =  await this.$store.dispatch({
			    type:'role/getRoleForEdit',
			    data:{id:this.datas.id}
		    })
		    // console.log(permissions)
		    // let data = this.$store.state.role.permissions;
		    if(data && permissions){
			    data.forEach((item:any,index:any) => {
				    let checked = false;
				    this.permissionData[0].children.push({
					    title:item.displayName,
					    value:item.name,
					    selected:false,
					    expand:false,
					    //遍历已有权限list 得到否选中
					    checked:checked,
					    children:[]
				    })
				    item.children.forEach((item_c:any) => {
					    this.permissionData[0].children[index].children.push({
						    title:item_c.displayName,
						    value:item_c.name,
						    selected:false,
						    expand:false,
						    //遍历已有权限list 得到否选中
						    checked:permissions.includes(item_c.name),
					    })
				    });
			    });
		    }

	    }
        cancel(){
            (this.$refs.roleForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }else{
                this.role=Util.extend(true,{},this.$store.state.role.editRole);
            }
        }
        roleRule={
            name:[{required: true,message:this.L('FieldIsRequired',undefined,this.L('RoleName')),trigger: 'blur'}],
            displayName:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('DisplayName')),trigger: 'blur'}]
        }
    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/role/edit-role.vue